module.exports = __webpack_public_path__ + "img/steven-pro.dd0bb66f.jpg";